/** 工作台 **/
<template>
  <div class="workbench-page">
    <!-- 顶部信息栏 -->
    <div class="workbench-header">
      <div class="header-left">
        <greeting-card />
        <div class="header-divider"></div>
        <stats-card :stats="bulletin" />
      </div>
      <div class="header-right">
        <date-card />
        <weather-card 
          ref="weatherCard" 
          @weather-loaded="onWeatherLoaded"
          @forecast-loaded="onForecastLoaded" />
      </div>
    </div>

    <!-- 运营预警区域 -->
    <alert-card 
      :weather="weatherData" 
      :forecast="forecastData" 
      class="workbench-alert" />

    <!-- 顶部区域：快捷入口 + 数据简报 -->
    <div class="workbench-top">
      <!-- 快捷入口 - 客运站 platformType === 2 -->
      <div class="workbench-section quick-entry-section" v-if="mixinUserInfo.platformType === 2">
        <div class="section-header">
          <div class="section-title">
            <i class="el-icon-s-grid"></i>
            <span>快捷入口</span>
          </div>
        </div>
        <div class="quick-entry-grid station-grid">
          <div class="entry-card card-warning" @click="pathTo(24, { path: '/dispatchCustomize' })">
            <div class="card-icon"><i class="el-icon-wallet"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.orderUnpaidNum || 0 }}</div>
              <div class="card-label">待支付</div>
            </div>
          </div>
          <div class="entry-card card-primary" @click="pathTo(8, { path: '/orderCustomize', query: { status: 10 } })">
            <div class="card-icon"><i class="el-icon-time"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.orderToStartNum || 0 }}</div>
              <div class="card-label">待开始</div>
            </div>
          </div>
          <div class="entry-card card-success" @click="pathTo(8, { path: '/orderCustomize', query: { status: '15,20,25,30,35,40' } })">
            <div class="card-icon"><i class="el-icon-truck"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.orderOnTheWayNum || 0 }}</div>
              <div class="card-label">行程中</div>
            </div>
          </div>
          <div class="entry-card card-danger" @click="pathTo(18, { path: '/driverAudit', query: { status: 2 } })">
            <div class="card-icon"><i class="el-icon-user"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.driverWaitAuditNum || 0 }}</div>
              <div class="card-label">待审核</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 快捷入口 - 定制客运 platformType === 1 -->
      <div class="workbench-section quick-entry-section" v-if="mixinUserInfo.platformType === 1">
        <div class="section-header">
          <div class="section-title">
            <i class="el-icon-s-grid"></i>
            <span>快捷入口</span>
          </div>
        </div>
        <div class="quick-entry-grid customize-grid">
          <!-- 专线订单 -->
          <div class="entry-card card-large card-primary">
            <div class="card-header-row">
              <div class="card-icon"><i class="el-icon-s-order"></i></div>
              <span class="card-title">专线订单</span>
            </div>
            <div class="card-stats-row">
              <div class="stat-item" @click="pathTo(24, { path: '/dispatchCustomize' })">
                <div class="stat-value">{{ liveData.orderToAssignNum || 0 }}</div>
                <div class="stat-label">等待指派</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item" @click="pathTo(52, { path: '/order', query: { tab: 'orderCustomize' } })">
                <div class="stat-value">{{ liveData.orderToStartNum || 0 }}</div>
                <div class="stat-label">待开始</div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-item" @click="pathTo(52, { path: '/order', query: { tab: 'orderCustomize', status: '15,20,25,30,35,40' } })">
                <div class="stat-value">{{ liveData.orderOnTheWayNum || 0 }}</div>
                <div class="stat-label">行程中</div>
              </div>
            </div>
          </div>
          <div class="entry-card card-warning" @click="pathTo(52, { path: '/order', query: { tab: 'orderCustomizeChartered' } })">
            <div class="card-icon"><i class="el-icon-s-promotion"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.intercityCharteredNum || 0 }}</div>
              <div class="card-label">专线包车</div>
            </div>
          </div>
          <div class="entry-card card-danger" @click="pathTo(18, { path: '/driverAudit', query: { status: 2 } })">
            <div class="card-icon"><i class="el-icon-user"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.driverWaitAuditNum || 0 }}</div>
              <div class="card-label">待审核司机</div>
            </div>
          </div>
          <div class="entry-card card-success" @click="pathTo(52, { path: '/order', query: { tab: 'orderChartered' } })">
            <div class="card-icon"><i class="el-icon-location-outline"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.charteredNum || 0 }}</div>
              <div class="card-label">旅游包车</div>
            </div>
          </div>
          <div class="entry-card card-info" @click="pathTo(34, { path: '/settlement', query: { status: 1 } })">
            <div class="card-icon"><i class="el-icon-s-check"></i></div>
            <div class="card-info">
              <div class="card-value">{{ liveData.settlementWaitAuditNum || 0 }}</div>
              <div class="card-label">待审核结算</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 数据简报 -->
      <div class="workbench-section data-brief-section">
        <div class="section-header">
          <div class="section-title">
            <i class="el-icon-data-analysis"></i>
            <span>数据简报</span>
          </div>
          <div class="section-actions">
            <custom-radio-date :value="0" @changeFn="changeBulletinFn" :radioGroup="[
              { value: '0', label: '实时' },
              { value: 1, label: '昨日' },
              { value: 2, label: '7天' },
              { value: 3, label: '30天' },
              { value: 4, label: '半年' },
              { value: 5, label: '一年' },
            ]"></custom-radio-date>
            <el-select clearable v-model="value" filterable placeholder="全部机构" size="small" @change="queryFn" style="width: 120px; margin-left: 8px;">
              <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name"></el-option>
            </el-select>
          </div>
        </div>
        <div class="data-brief-grid">
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#409EFF,#66B1FF)"><i class="el-icon-document"></i></div>
            <div class="brief-content">
              <div class="brief-label">创建订单</div>
              <div class="brief-value">{{ formatCount(bulletin.orderCreatNum) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#E6A23C,#EBB563)"><i class="el-icon-refresh-left"></i></div>
            <div class="brief-content">
              <div class="brief-label">退票订单</div>
              <div class="brief-value text-warning">{{ formatCount(bulletin.orderRefundNum) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#67C23A,#85CE61)"><i class="el-icon-circle-check"></i></div>
            <div class="brief-content">
              <div class="brief-label">完成订单</div>
              <div class="brief-value text-success">{{ formatCount(bulletin.orderFinishNum) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#909399,#A6A9AD)"><i class="el-icon-user"></i></div>
            <div class="brief-content">
              <div class="brief-label">注册用户</div>
              <div class="brief-value">{{ formatCount(bulletin.customerNum) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#409EFF,#66B1FF)"><i class="el-icon-bank-card"></i></div>
            <div class="brief-content">
              <div class="brief-label">支付金额</div>
              <div class="brief-value text-primary">{{ formatMoney(bulletin.orderPayCount) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#E6A23C,#EBB563)"><i class="el-icon-sell"></i></div>
            <div class="brief-content">
              <div class="brief-label">退票金额</div>
              <div class="brief-value text-warning">{{ formatMoney(bulletin.orderRefundFeeCount) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#67C23A,#85CE61)"><i class="el-icon-money"></i></div>
            <div class="brief-content">
              <div class="brief-label">成交金额</div>
              <div class="brief-value text-success">{{ formatMoney(bulletin.orderRealFeeCount) }}</div>
            </div>
          </div>
          <div class="brief-item">
            <div class="brief-icon" style="background:linear-gradient(135deg,#9B59B6,#B07CC6)"><i class="el-icon-s-finance"></i></div>
            <div class="brief-content">
              <div class="brief-label">平台收入</div>
              <div class="brief-value text-primary">{{ formatMoney(bulletin.companyIncome) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 增强统计分析入口 -->
    <div class="workbench-section analysis-entry-section">
      <div class="section-header">
        <div class="section-title">
          <i class="el-icon-data-analysis"></i>
          <span>增强统计分析</span>
        </div>
        <el-button type="primary" size="small" icon="el-icon-right" @click="goAnalysis">进入统计分析中心</el-button>
      </div>
      <div class="analysis-preview-grid">
        <div class="analysis-preview-card">
          <div class="preview-icon" style="background:linear-gradient(135deg,#409EFF,#66B1FF)"><i class="el-icon-pie-chart"></i></div>
          <div class="preview-info">
            <div class="preview-label">客单价</div>
            <div class="preview-value">{{ formatMoney(analysisOverview.avgOrderFee) }}</div>
          </div>
        </div>
        <div class="analysis-preview-card pct-card">
          <div class="preview-icon" style="background:linear-gradient(135deg,#67C23A,#85CE61)"><i class="el-icon-user"></i></div>
          <div class="preview-info">
            <div class="preview-label">新客占比</div>
            <div class="preview-pct">
              <span class="pct-num">{{ Number(analysisOverview.newCustomerRate) || 0 }}</span><span class="pct-sym">%</span>
            </div>
            <div class="pct-bar"><div class="pct-fill" :style="{width: (Number(analysisOverview.newCustomerRate)||0)+'%', background:'#67C23A'}"></div></div>
          </div>
        </div>
        <div class="analysis-preview-card pct-card">
          <div class="preview-icon" style="background:linear-gradient(135deg,#E6A23C,#EBB563)"><i class="el-icon-location"></i></div>
          <div class="preview-info">
            <div class="preview-label">本地占比</div>
            <div class="preview-pct">
              <span class="pct-num">{{ Number(analysisOverview.localRate) || 0 }}</span><span class="pct-sym">%</span>
            </div>
            <div class="pct-bar"><div class="pct-fill" :style="{width: (Number(analysisOverview.localRate)||0)+'%', background:'#E6A23C'}"></div></div>
          </div>
        </div>
        <div class="analysis-preview-card">
          <div class="preview-icon" style="background:linear-gradient(135deg,#b37feb,#d3adf7)"><i class="el-icon-place"></i></div>
          <div class="preview-info">
            <div class="preview-label">海外订单</div>
            <div class="preview-value">{{ formatCount(analysisOverview.overseasOrders) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部区域：统计报表 -->
    <div class="workbench-section chart-section">
      <div class="section-header">
        <div class="section-title">
          <i class="el-icon-s-data"></i>
          <span>统计报表</span>
        </div>
        <div class="section-actions">
          <custom-radio-date :value="'0'" @changeFn="changeStatFn" :radioGroup="[
            { value: '0', label: '实时' },
            { value: 1, label: '昨日' },
            { value: 2, label: '7天' },
            { value: 3, label: '30天' },
            { value: 4, label: '半年' },
            { value: 5, label: '一年' },
          ]"></custom-radio-date>
          <el-select clearable v-model="value1" filterable placeholder="全部机构" size="small" @change="queryFn1" style="width: 120px; margin-left: 8px;">
            <el-option v-for="val in options" :key="val.id" :value="val.id" :label="val.name"></el-option>
          </el-select>
        </div>
      </div>
      <div class="chart-container">
        <div id="orderChart"></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import CustomRadioDate from "../../components/customRadioDate";
import { GreetingCard, WeatherCard, DateCard, StatsCard, AlertCard } from "@/components/WorkbenchHeader";

export default {
  components: { CustomRadioDate, GreetingCard, WeatherCard, DateCard, StatsCard, AlertCard },
  data() {
    return {
      organizationId: "",
      organizationId1: "",
      options: [],
      value: "",
      value1: "",
      // 数据简报数据
      bulletin: {},
      // 增强统计概览数据
      analysisOverview: {},
      // 实时数据
      liveData: {},
      // 统计报表
      stat: [],
      // 统计报表查询时间
      time: {
        timeType:'0'
      },
      time1: {},
      // 图表实例
      chartInstance: null,
      // resize处理函数引用
      resizeHandler: null,
      // 天气数据（用于预警组件）
      weatherData: {},
      forecastData: []
    };
  },
  created() {
    this.liveDataFn();
  },
  async mounted() {
    await this.mixinOrganizations();
    this.options = this.organizations;
    // 初始化加载统计报表数据
    this.statFn(this.organizationId1);
    // 加载增强统计概览数据
    this.fetchAnalysisOverview();
  },
  beforeDestroy() {
    // 移除resize监听
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    // 销毁图表实例，避免内存泄漏
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    onWeatherLoaded(weather) {
      this.weatherData = weather;
    },
    onForecastLoaded(forecast) {
      this.forecastData = forecast;
    },
    fmoney(s, n) {
      n = n > 0 && n <= 20 ? n : 2;
      s = parseFloat((s + "").replace(/[^\d-]/g, "")).toFixed(n) + "";
      let l = s.split(".")[0].split("").reverse(),
          r = s.split(".")[1];
      let t = "";
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
      }
      return t.split("").reverse().join("") + "." + r;
    },
    formatMoney(val) {
      const num = parseFloat(val) || 0;
      if (num >= 1e8) return "¥" + (num / 1e8).toFixed(2) + "亿";
      if (num >= 1e4) return "¥" + (num / 1e4).toFixed(2) + "万";
      return "¥" + num.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatCount(val) {
      const num = parseInt(val) || 0;
      if (num >= 1e8) return (num / 1e8).toFixed(2) + "亿";
      if (num >= 1e4) return (num / 1e4).toFixed(1) + "万";
      return num.toLocaleString();
    },
    queryFn(e) {
      this.organizationId = e;
      this.bulletinFn(this.time1, this.organizationId);
    },
    queryFn1(e) {
      this.organizationId1 = e;
      this.statFn(this.organizationId1);
    },
    pathTo(id, path) {
      if (this.menuPreFn(id)) {
        this.$router.push(path);
      }
    },
    /**
     * 创建图表
     */
    stackedAreaFn() {
      const chartDom = document.getElementById('orderChart');
      this.chartInstance = echarts.init(chartDom);

      const option = {
        backgroundColor: '#FAFBFC',
        // 柱状图间隙配置
        barCategoryGap: '30%', // 柱状图类间距（缩小间隙）
        grid: {
          left: '5%',
          right: '8%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        title: {
          text: '订单统计与完成率分析',
          left: 'center',
          top: 10,
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#2C3E50'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#95A5A6'
            }
          },
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#34495E',
          borderWidth: 1,
          textStyle: {
            color: '#FFF',
            fontSize: 12
          },
          formatter: function (params) {
            let result = '<div style="font-weight: bold; margin-bottom: 5px;">' + params[0].name + '</div>';
            params.forEach(param => {
              const color = param.color.colorStops ? param.color.colorStops[0].color : param.color;
              if (param.seriesName.includes('率')) {
                result += '<div style="margin: 3px 0;"><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>' + param.seriesName + ': <strong>' + param.value + '%</strong></div>';
              } else {
                result += '<div style="margin: 3px 0;"><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>' + param.seriesName + ': <strong>' + param.value + '</strong></div>';
              }
            });
            return result;
          }
        },
        legend: {
          data: ['创建订单数', '完成订单数', '退票订单数', '完成率', '退票率'],
          bottom: 15,
          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#34495E'
          },
          icon: 'roundRect'
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: '#7F8C8D',
              fontSize: 11
            },
            axisLine: {
              lineStyle: {
                color: '#BDC3C7'
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '订单数量',
            position: 'left',
            nameTextStyle: {
              color: '#34495E',
              fontSize: 12
            },
            axisLabel: {
              formatter: '{value}',
              color: '#7F8C8D',
              fontSize: 11
            },
            axisLine: {
              lineStyle: {
                color: '#BDC3C7'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#ECF0F1',
                type: 'dashed'
              }
            }
          },
          {
            type: 'value',
            name: '比率(%)',
            position: 'right',
            nameTextStyle: {
              color: '#34495E',
              fontSize: 12
            },
            axisLabel: {
              formatter: '{value}%',
              color: '#7F8C8D',
              fontSize: 11
            },
            axisLine: {
              lineStyle: {
                color: '#BDC3C7'
              }
            },
            splitLine: {
              show: false
            },
            min: 0,
            max: 100
          }
        ],
        series: [
          {
            name: '创建订单数',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            barGap: '0%', // 柱状间隙
            barWidth: '10%', // 柱子宽度
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {offset: 0, color: '#3498DB'},
                  {offset: 1, color: '#2980B9'}
                ]
              }
            },
            emphasis: {
              itemStyle: {
                color: '#3498DB'
              }
            }
          },
          {
            name: '完成订单数',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            barGap: '0%', // 柱状间隙
            barWidth: '10%', // 柱子宽度
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {offset: 0, color: '#F39C12'},
                  {offset: 1, color: '#E67E22'}
                ]
              }
            },
            emphasis: {
              itemStyle: {
                color: '#F39C12'
              }
            }
          },
          {
            name: '退票订单数',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            barGap: '0%', // 柱状间隙
            barWidth: '10%', // 柱子宽度
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {offset: 0, color: '#9B59B6'},
                  {offset: 1, color: '#8E44AD'}
                ]
              }
            },
            emphasis: {
              itemStyle: {
                color: '#9B59B6'
              }
            }
          },
          {
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            data: [],
            smooth: true,
            itemStyle: {
              color: '#27AE60',
              borderColor: '#27AE60',
              borderWidth: 1
            },
            lineStyle: {
              color: '#27AE60',
              width: 2,
              type: 'solid'
            },
            symbol: 'circle',
            symbolSize: 8,
            emphasis: {
              itemStyle: {
                color: '#229954',
                borderColor: '#229954',
                borderWidth: 3
              },
              lineStyle: {
                width: 3
              }
            }
          },
          {
            name: '退票率',
            type: 'line',
            yAxisIndex: 1,
            data: [],
            smooth: true,
            itemStyle: {
              color: '#E74C3C',
              borderColor: '#E74C3C',
              borderWidth: 2
            },
            lineStyle: {
              color: '#E74C3C',
              width: 2,
              type: 'solid'
            },
            symbol: 'circle',
            symbolSize: 8,
            emphasis: {
              itemStyle: {
                color: '#C0392B',
                borderColor: '#C0392B',
                borderWidth: 3
              },
              lineStyle: {
                width: 3
              }
            }
          }
        ]
      };

      this.chartInstance.setOption(option);

      // 监听窗口resize事件
      this.resizeHandler = () => {
        if (this.chartInstance) {
          this.chartInstance.resize();
        }
      };
      window.addEventListener('resize', this.resizeHandler);
    },
    /**
     * 图表数据赋值
     */
    dataFn() {
      if (!this.chartInstance) {
        this.stackedAreaFn();
      }

      const xAxisData = [];
      const createNumData = [];
      const finishNumData = [];
      const refundNumData = [];
      const finishRateData = [];
      const refundRateData = [];

      this.stat.forEach((item) => {
        const createNum = item && item.orderCreateNum ? item.orderCreateNum : 0;
        const finishNum = item && item.orderFinishNum ? item.orderFinishNum : 0;
        const refundNum = item && item.orderRefundNum ? item.orderRefundNum : 0;

        // 计算完成率和退票率
        const finishRate = createNum > 0 ? Math.round((finishNum / createNum) * 100 * 100) / 100 : 0;
        const refundRate = createNum > 0 ? Math.round((refundNum / createNum) * 100 * 100) / 100 : 0;

        // 格式化时间显示
        let timeStr = item.time;
        if (timeStr) {
          // 如果是完整的日期时间格式，只显示日期部分
          if (timeStr.includes(' ')) {
            timeStr = timeStr.split(' ')[0];
          }
          // 如果是yyyy-mm-dd格式，转换为mm-dd
          if (timeStr.includes('-') && timeStr.length === 10) {
            timeStr = timeStr.substring(5);
          }
        }

        xAxisData.push(timeStr);
        createNumData.push(createNum);
        finishNumData.push(finishNum);
        refundNumData.push(refundNum);
        finishRateData.push(finishRate);
        refundRateData.push(refundRate);
      });

      // 更新图表数据
      this.chartInstance.setOption({
        xAxis: {
          data: xAxisData
        },
        series: [
          {data: createNumData},
          {data: finishNumData},
          {data: refundNumData},
          {data: finishRateData},
          {data: refundRateData}
        ]
      });
    },
    /**
     * 数据简报时间变化
     */
    changeBulletinFn(time) {
      this.time1 = time;
      this.bulletinFn(this.time1, this.organizationId);
    },
    /**
     * 统计报表时间变化
     */
    changeStatFn(time) {
      // console.log(time, 2332);
      this.time = time;
      this.statFn(this.organizationId1);
    },
    /**
     * 获取实时数据
     */
    async liveDataFn() {
      let url = this.mixinUserInfo.platformType === 2 ? "/api/v1/manage/statistics/station" : "/api/v1/manage/statistics";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.liveData = data.data || {};
      }
    },
    /**
     * 获取数据简报
     */
    async bulletinFn(time, organizationId) {
      let params = {};
      params.startTime = time.startTime;
      params.endTime = time.endTime;
      params.timeType = time.timeType;
      params.organizationId = organizationId;

      let url = "/api/v1/manage/statistics/dataBriefing";
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.bulletin = data.data || {};
      }
    },
    /**
     * 获取统计报表
     */
    async statFn(organizationId) {
      let url = "/api/v1/manage/statistics/report";
      let params = this.$utils.deepCopyFn(this.time);
      params.organizationId = organizationId;
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.stat = data.data.statisticsReportVos || [];

        this.dataFn();
      }
    },
    /**
     * 统计类型变化
     */
    changeFn() {
      this.statFn(this.organizationId1);
    },
    /**
     * 跳转到增强统计分析页面
     */
    goAnalysis() {
      this.$router.push({ path: '/analysisStatistics' });
    },
    /**
     * 获取增强统计概览数据（客单价/新客占比/本地占比/海外订单）
     */
    async fetchAnalysisOverview() {
      try {
        const params = { timeType: 0 };
        const res = await this.$axios.get('/api/v1/manage/analysis/overview', params);
        if (res && res.code === 1) {
          this.analysisOverview = res.data || {};
        }
      } catch (e) {
        console.warn('增强统计概览加载失败', e);
      }
    },
  },

};
</script>

<style lang="less">
.workbench-page {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 16px;
  background: #f5f7fa;
  box-sizing: border-box;
  overflow-y: auto;

  // 顶部信息栏
  .workbench-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 12px;
    padding: 20px 28px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .header-left {
      display: flex;
      align-items: center;
      gap: 24px;

      .header-divider {
        width: 1px;
        height: 40px;
        background: linear-gradient(180deg, transparent, #e4e7ed, transparent);
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }

  // 运营预警区域
  .workbench-alert {
    margin-bottom: 16px;
  }

  // 顶部区域
  .workbench-top {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
  }

  // 通用区块样式 - iOS 26 紧凑风格
  .workbench-section {
    background: rgba(255, 255, 255, 0.98);
    border-radius: 14px;
    padding: 14px 18px;
    border: 1px solid rgba(0, 0, 0, 0.04);
    // iOS 26 柔和阴影
    box-shadow: 
      0 1px 2px rgba(0, 0, 0, 0.02),
      0 2px 8px rgba(0, 0, 0, 0.03);
    // 流畅过渡动画
    transition: 
      box-shadow 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
      transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    .section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      .section-title {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 600;
        color: @color-text-primary;
        letter-spacing: -0.2px;

        i {
          margin-right: 8px;
          font-size: 17px;
          color: @color-primary;
          transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        &:hover i {
          transform: scale(1.05);
        }
      }

      .section-actions {
        display: flex;
        align-items: center;
        
        .el-select {
          margin-bottom: 10px;
          height: 32px;
          .el-input__inner {
            height: 32px;
            line-height: 32px;
            font-size: 12px;
          }
          
          .el-input__suffix {
            .el-input__icon {
              line-height: 32px;
            }
          }
        }
      }
    }
  }

  // 快捷入口区块 - iOS 26 紧凑风格
  .quick-entry-section {
    width: 380px;
    flex-shrink: 0;

    .quick-entry-grid {
      display: grid;
      gap: 10px;

      &.station-grid {
        grid-template-columns: 1fr 1fr;
      }

      &.customize-grid {
        grid-template-columns: 1fr 1fr;
        
        .card-large {
          grid-column: 1 / span 2;
        }
      }
    }

    .entry-card {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      border-radius: 12px;
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.03);
      // iOS 26 卡片柔和阴影
      box-shadow: 
        0 1px 2px rgba(0, 0, 0, 0.03),
        0 2px 4px rgba(0, 0, 0, 0.02);
      // 流畅弹性动画
      transition: 
        transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        box-shadow 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        border-color 0.25s ease;

      &:hover {
        transform: translateY(-1px);
        border-color: rgba(0, 0, 0, 0.05);
        box-shadow: 
          0 2px 4px rgba(0, 0, 0, 0.04),
          0 4px 12px rgba(0, 0, 0, 0.05);
      }
      
      &:active {
        transform: translateY(0) scale(0.98);
        transition-duration: 0.1s;
      }

      .card-icon {
        width: 34px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        flex-shrink: 0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
        transition: transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);

        i {
          font-size: 15px;
          color: #fff;
        }
      }
      
      &:hover .card-icon {
        transform: scale(1.03);
      }

      .card-info {
        flex: 1;

        .card-value {
          font-size: 20px;
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: -0.3px;
        }

        .card-label {
          font-size: 11px;
          color: rgba(60, 60, 67, 0.6);
          margin-top: 2px;
          font-weight: 500;
        }
      }

      // 大卡片样式 - iOS 26 紧凑风格
      &.card-large {
        flex-direction: column;
        align-items: stretch;
        padding: 12px 14px;

        .card-header-row {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          .card-icon {
            margin-right: 8px;
          }

          .card-title {
            font-size: 13px;
            font-weight: 600;
            color: @color-text-primary;
            letter-spacing: -0.2px;
          }
        }

        .card-stats-row {
          display: flex;
          align-items: center;
          justify-content: space-around;

          .stat-item {
            text-align: center;
            padding: 6px 10px;
            border-radius: 10px;
            cursor: pointer;
            flex: 1;
            transition: 
              background 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);

            &:hover {
              background: fade(@color-primary, 6%);
              transform: scale(1.02);
            }
            
            &:active {
              transform: scale(0.98);
              transition-duration: 0.08s;
            }

            .stat-value {
              font-size: 22px;
              font-weight: 700;
              color: @color-primary;
              letter-spacing: -0.3px;
            }

            .stat-label {
              font-size: 11px;
              color: rgba(60, 60, 67, 0.6);
              margin-top: 2px;
              font-weight: 500;
            }
          }

          .stat-divider {
            width: 1px;
            height: 26px;
            background: rgba(0, 0, 0, 0.06);
            border-radius: 1px;
          }
        }
      }

      // 颜色主题 - iOS 26 柔和配色（保持主题色）
      &.card-primary {
        background: fade(@color-primary, 6%);
        .card-icon { background: @color-primary; }
        .card-value { color: @color-primary; }
      }

      &.card-success {
        background: fade(@color-success, 8%);
        .card-icon { background: @color-success; }
        .card-value { color: @color-success; }
      }

      &.card-warning {
        background: fade(@color-warning, 10%);
        .card-icon { background: @color-warning; }
        .card-value { color: @color-warning; }
      }

      &.card-danger {
        background: fade(@color-danger, 8%);
        .card-icon { background: @color-danger; }
        .card-value { color: @color-danger; }
      }

      &.card-info {
        background: fade(@color-info, 10%);
        .card-icon { background: @color-info; }
        .card-value { color: @color-info; }
      }
    }
  }

  // 数据简报区块 - iOS 26 紧凑风格
  .data-brief-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    .data-brief-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      flex: 1;
      .brief-item {
        display: flex;
        align-items: center;
        padding: 12px 14px;
        background: rgba(250, 251, 252, 0.9);
        border-radius: 12px;
        border: 1px solid rgba(0, 0, 0, 0.03);
        box-shadow: 0 1px 2px rgba(0,0,0,0.02), 0 2px 4px rgba(0,0,0,0.02);
        transition: transform 0.25s ease, box-shadow 0.25s ease;
        &:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }

        .brief-icon {
          width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          margin-right: 12px;
          i { color: #fff; font-size: 16px; }
        }

        .brief-content {
          min-width: 0; flex: 1;
          .brief-label {
            font-size: 11px; color: rgba(60,60,67,0.6); font-weight: 500;
            margin-bottom: 3px; white-space: nowrap;
          }
          .brief-value {
            font-size: 16px; font-weight: 700; color: @color-text-primary;
            letter-spacing: -0.3px; white-space: nowrap;
            &.text-primary { color: @color-primary; }
            &.text-success { color: @color-success; }
            &.text-warning { color: @color-warning; }
            &.text-danger { color: @color-danger; }
          }
        }
      }
    }
  }

  // 增强统计分析入口区块
  .analysis-entry-section {
    margin-bottom: 16px;

    .analysis-preview-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;

      .analysis-preview-card {
        display: flex;
        align-items: center;
        padding: 14px 16px;
        background: rgba(250, 251, 252, 0.9);
        border-radius: 12px;
        border: 1px solid rgba(0, 0, 0, 0.03);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02), 0 2px 4px rgba(0, 0, 0, 0.02);
        transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .preview-icon {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          flex-shrink: 0;
          i { color: #fff; font-size: 16px; }
        }

        .preview-info {
          flex: 1; min-width: 0;
          .preview-label {
            font-size: 11px; color: rgba(60,60,67,0.6); font-weight: 500;
            margin-bottom: 3px;
          }
          .preview-value {
            font-size: 18px; font-weight: 700; color: @color-text-primary;
            letter-spacing: -0.3px; white-space: nowrap;
          }
          .preview-pct {
            .pct-num { font-size: 22px; font-weight: 700; color: @color-text-primary; }
            .pct-sym { font-size: 14px; font-weight: 600; color: rgba(60,60,67,0.5); margin-left: 1px; }
          }
          .pct-bar {
            height: 4px; background: rgba(0,0,0,0.06); border-radius: 2px;
            margin-top: 5px; overflow: hidden;
            .pct-fill { height: 100%; border-radius: 2px; transition: width 0.6s ease; max-width: 100%; }
          }
        }
      }
    }
  }

  // 统计报表区块
  .chart-section {
    .chart-container {
      #orderChart {
        width: 100%;
        height: 360px;
      }
    }
  }
}
</style>
